/**
 * Where to send a signed-out browser: the login page, carrying the current
 * location as `?next=` so single sign-on (or a password login) returns the
 * person to where they were. Never nests a login page inside `next`.
 */
export const isLoginPath = (pathname: string) =>
  pathname === '/login' || pathname.startsWith('/login/');

export const loginPathFor = (pathname: string, search = '', hash = '') => {
  if (isLoginPath(pathname) || pathname === '/') return '/login';
  return `/login?next=${encodeURIComponent(`${pathname}${search}${hash}`)}`;
};

export const currentLoginPath = () =>
  typeof window === 'undefined'
    ? '/login'
    : loginPathFor(window.location.pathname, window.location.search, window.location.hash);
